import { ChevronUp, RotateCcw } from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setToogleHeader } from "../../core/redux/action";
import { OverlayTrigger, Tooltip, Modal } from "react-bootstrap";
import { Select, message } from "antd";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import formatDateWithTimezone from "../../utils/dateUtils";
import { dateFilterParams } from "../../utils/dateUtils";
import TransactionModal from "./components/TransactionModal";
import OrderOffersModal from "./components/OrderOffersModal";
import OrderRevisionModal from "./components/OrderRevisionModal";
import RealAuthTransactionsModal from "./components/RealAuthTransactionsModal";
import RealNMITransactionsModal from "./components/RealNMITransactionsModal";
import TigerTechSalesModal from "./components/TigerTechSalesModal";
import WebOrdersWithoutStripeModal from "./components/WebOrdersWithoutStripeModal";

import { AllCommunityModule, ModuleRegistry, provideGlobalGridOptions } from "ag-grid-community";

import { fetchSublyticsOrders, syncSublyticsOrders } from "../../core/api/data";

ModuleRegistry.registerModules([AllCommunityModule]);
provideGlobalGridOptions({ theme: "legacy" });

const SublyticsOrders = ({ timezone, filters, refreshTrigger }) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  // We'll use the brand from filters instead of maintaining our own state
  const [rowData, setRowData] = useState([]);
  const [loadingFetch, setloadingFetch] = useState(false);
  const [syncInProgress, setSyncInProgress] = useState(false);
  const [lastSyncTime, setLastSyncTime] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const gridRef = useRef(null);
  const pendingRequestRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showOffersModal, setShowOffersModal] = useState(false);
  const [selectedOffersOrder, setSelectedOffersOrder] = useState(null);
  const [showRevisionsModal, setShowRevisionsModal] = useState(false);
  const [selectedRevisionOrder, setSelectedRevisionOrder] = useState(null);
  const [showRealAuthModal, setShowRealAuthModal] = useState(false);
  const [selectedRealAuthOrder, setSelectedRealAuthOrder] = useState(null);
  const [showRealNMIModal, setShowRealNMIModal] = useState(false);
  const [selectedRealNMIOrder, setSelectedRealNMIOrder] = useState(null);
  const [showTigerTechModal, setShowTigerTechModal] = useState(false);
  const [selectedTigerTechSaleId, setSelectedTigerTechSaleId] = useState(null);
  const [showWebOrdersWithoutStripeModal, setShowWebOrdersWithoutStripeModal] = useState(false);
  const [selectedWebOrdersMerchant, setSelectedWebOrdersMerchant] = useState(null);

  const columnDefs = [
    { headerName: "#", field: "index", width: 70, resizable: true },
    { headerName: "Order ID", field: "id", width: 120, resizable: true },
    { headerName: "Credentials Name", field: "credentials_name", width: 150, resizable: true },
    { headerName: "Campaign ID", field: "campaign_id", width: 120, resizable: true },

    // Customer nested object
    {
      headerName: "Customer Name",
      valueGetter: (p) => {
        const f = p.data.customer?.first_name || "";
        const l = p.data.customer?.last_name || "";
        return `${f} ${l}`.trim();
      },
      width: 200,
      resizable: true,
    },
    {
      headerName: "Customer Email",
      valueGetter: (p) => p.data.customer?.email || "",
      width: 200,
      resizable: true,
    },
    {
      headerName: "Customer Phone",
      valueGetter: (p) => p.data.customer?.phone || "",
      width: 140,
      resizable: true,
    },

    {
      headerName: "Total Sublytics Amount",
      field: "total_transaction_amount",
      width: 100,
      resizable: true,
    },
    // {
    //   headerName: "Total Authorize.net Transcation", field: "total_authorize_dot_net_amount", width: 250, resizable: true,
    //   cellStyle: (params) => {
    //     if (params.data.total_transaction_amount === params.value) {
    //       return { color: 'green', fontWeight: 'bold' };
    //     }
    //     return null;
    //   }
    // },
    {
      headerName: "Is Fraud",
      valueGetter: (p) => p.data.customer?.is_fraud || "",
      width: 120,
      resizable: true,
    },

    // Customer address billing
    {
      headerName: "Billing FName",
      valueGetter: (p) => p.data.customer_address_billing?.fname || "",
      width: 130,
      resizable: true,
    },
    {
      headerName: "Billing LName",
      valueGetter: (p) => p.data.customer_address_billing?.lname || "",
      width: 130,
      resizable: true,
    },
    {
      headerName: "Billing State",
      valueGetter: (p) => p.data.customer_address_billing?.state || "",
      width: 100,
      resizable: true,
    },
    {
      headerName: "Billing City",
      valueGetter: (p) => p.data.customer_address_billing?.city || "",
      width: 130,
      resizable: true,
    },
    {
      headerName: "Billing Country",
      valueGetter: (p) => p.data.customer_address_billing?.country || "",
      width: 100,
      resizable: true,
    },
    {
      headerName: "Billing Zipcode",
      valueGetter: (p) => p.data.customer_address_billing?.zipcode || "",
      width: 100,
      resizable: true,
    },

    // Customer address shipping
    {
      headerName: "Shipping FName",
      valueGetter: (p) => p.data.customer_address_shipping?.fname || "",
      width: 130,
      resizable: true,
    },
    {
      headerName: "Shipping LName",
      valueGetter: (p) => p.data.customer_address_shipping?.lname || "",
      width: 130,
      resizable: true,
    },
    {
      headerName: "Shipping State",
      valueGetter: (p) => p.data.customer_address_shipping?.state || "",
      width: 100,
      resizable: true,
    },
    {
      headerName: "Shipping City",
      valueGetter: (p) => p.data.customer_address_shipping?.city || "",
      width: 130,
      resizable: true,
    },
    {
      headerName: "Shipping Zipcode",
      valueGetter: (p) => p.data.customer_address_shipping?.zipcode || "",
      width: 100,
      resizable: true,
    },

    // Customer card
    {
      headerName: "Card Number",
      valueGetter: (p) => p.data.customer_card?.card_number || "",
      width: 180,
      resizable: true,
    },
    {
      headerName: "Card Type",
      valueGetter: (p) => p.data.customer_card?.card_type_id || "",
      width: 120,
      resizable: true,
    },
    {
      headerName: "Card Exp Month",
      valueGetter: (p) => p.data.customer_card?.card_exp_month || "",
      width: 120,
      resizable: true,
    },
    {
      headerName: "Card Exp Year",
      valueGetter: (p) => p.data.customer_card?.card_exp_year || "",
      width: 120,
      resizable: true,
    },

    {
      headerName: "Customer Address Billing ID",
      field: "customers_address_billing_id",
      width: 200,
      resizable: true,
    },
    {
      headerName: "Customer Address Shipping ID",
      field: "customers_address_shipping_id",
      width: 200,
      resizable: true,
    },

    {
      headerName: "Date Authorized",
      field: "date_authorized",
      width: 220,
      resizable: true,
      filter: "agDateColumnFilter",
      filterParams: dateFilterParams,
      valueFormatter: (p) => formatDateWithTimezone(p.value, timezone),
    },
    {
      headerName: "Date Auto Capture",
      field: "date_auto_capture",
      width: 220,
      resizable: true,
      filter: "agDateColumnFilter",
      filterParams: dateFilterParams,
      valueFormatter: (p) => formatDateWithTimezone(p.value, timezone),
    },
    {
      headerName: "Date Capture",
      field: "date_capture",
      width: 220,
      resizable: true,
      filter: "agDateColumnFilter",
      filterParams: dateFilterParams,
      valueFormatter: (p) => formatDateWithTimezone(p.value, timezone),
    },
    {
      headerName: "Date Created",
      field: "date_created",
      width: 220,
      resizable: true,
      filter: "agDateColumnFilter",
      filterParams: dateFilterParams,
      valueFormatter: (p) => formatDateWithTimezone(p.value, timezone),
    },
    {
      headerName: "Date Modified",
      field: "date_modified",
      width: 220,
      resizable: true,
      filter: "agDateColumnFilter",
      filterParams: dateFilterParams,
      valueFormatter: (p) => formatDateWithTimezone(p.value, timezone),
    },
    {
      headerName: "Date Ordered",
      field: "date_ordered",
      width: 220,
      resizable: true,
      sortable: true,
      filter: "agDateColumnFilter",
      filterParams: dateFilterParams,
      valueFormatter: (p) => formatDateWithTimezone(p.value, timezone),
    },

    { headerName: "IP Address", field: "ip_address", width: 130, resizable: true },
    { headerName: "Is Test", field: "is_test", width: 100, resizable: true },
    { headerName: "Modified By", field: "modified_by", width: 180, resizable: true },

    { headerName: "Order Discount", field: "order_discount", width: 140, resizable: true },
    { headerName: "Order Notes", field: "order_notes", width: 250, resizable: true },

    { headerName: "Tracking 1", field: "tracking1", width: 120, resizable: true },
    { headerName: "Tracking 2", field: "tracking2", width: 120, resizable: true },

    {
      headerName: "Transactions",
      field: "transactions",
      sortable: false,
      filter: false,
      width: 200,
      resizable: true,
      cellRenderer: (params) => {
        if (!params.value || !Array.isArray(params.value) || params.value.length === 0) {
          return "No Transactions";
        }

        return (
          <button
            className="btn btn-xs btn-outline-info"
            onClick={() => {
              setSelectedOrder(params.data); // pass full order row, not just transactions array
              setShowModal(true);
            }}>
            View {params.value.length} {params.value.length === 1 ? "Transaction" : "Transactions"}
          </button>
        );
      },
    },
    {
      headerName: "Real Auth Transactions",
      field: "real_auth_transactions",
      sortable: false,
      filter: false,
      pinned: "right",
      width: 230,
      resizable: true,
      cellRenderer: (params) => {
        if (!params.value || !Array.isArray(params.value) || params.value.length === 0) {
          return "No Auth Transactions";
        }

        return (
          <button
            className="btn btn-xs btn-outline-success"
            onClick={() => {
              setSelectedRealAuthOrder(params.data);
              setShowRealAuthModal(true);
            }}>
            View {params.value.length}{" "}
            {params.value.length === 1 ? "Auth Transaction" : "Auth Transactions"}
          </button>
        );
      },
    },
    {
      headerName: "Real NMI Transactions",
      field: "real_nmi_transactions",
      sortable: false,
      filter: false,
      pinned: "right",
      width: 230,
      resizable: true,
      cellRenderer: (params) => {
        if (!params.value || !Array.isArray(params.value) || params.value.length === 0) {
          return "No NMI Transactions";
        }

        return (
          <button
            className="btn btn-xs btn-outline-primary"
            onClick={() => {
              setSelectedRealNMIOrder(params.data);
              setShowRealNMIModal(true);
            }}>
            View {params.value.length}{" "}
            {params.value.length === 1 ? "NMI Transaction" : "NMI Transactions"}
          </button>
        );
      },
    },
    {
      headerName: "Real Stripe Transactions",
      field: "real_stripe_transactions",
      sortable: false,
      filter: false,
      pinned: "right",
      width: 230,
      resizable: true,
      cellRenderer: (params) => {
        if (!params.value || !Array.isArray(params.value) || params.value.length === 0) {
          // If no transactions, check if there's a merchant name we can use for displaying web orders without stripe
          if (params.data.merchant_name) {
            return (
              <button
                className="btn btn-xs btn-outline-secondary"
                onClick={() => {
                  setSelectedWebOrdersMerchant(params.data.merchant_name);
                  setShowWebOrdersWithoutStripeModal(true);
                }}>
                See Web Orders Without Stripe
              </button>
            );
          }
          return "No Stripe Transactions";
        }

        return (
          <button
            className="btn btn-xs btn-outline-dark"
            onClick={() => {
              // For now, show web orders without stripe modal when this button is clicked
              setSelectedWebOrdersMerchant(params.data.merchant_name);
              setShowWebOrdersWithoutStripeModal(true);
            }}>
            View {params.value.length}{" "}
            {params.value.length === 1 ? "Stripe Transaction" : "Stripe Transactions"}
          </button>
        );
      },
    },
    {
      headerName: "Respective TigerTech Order",
      field: "respective_tiger_tech_order",
      sortable: false,
      filter: false,
      pinned: "right",
      width: 200,
      resizable: true,
      cellRenderer: (params) => {
        // If there's no respective_tiger_tech_order
        if (!params.data.respective_tiger_tech_order) {
          return "No TigerTech Order";
        }

        // Get the TigerTech sale ID from the respective_tiger_tech_order field
        const tigerTechSaleId = params.data.respective_tiger_tech_order;

        return (
          <button
            className="btn btn-xs btn-outline-warning"
            onClick={() => {
              setSelectedTigerTechSaleId(tigerTechSaleId);
              setShowTigerTechModal(true);
            }}>
            View TigerTech Order
          </button>
        );
      },
    },
    {
      headerName: "Order Offers",
      field: "order_offers",
      width: 150,
      resizable: true,
      sortable: false,
      filter: false,
      cellRenderer: (params) => {
        const offers = params.value || [];
        if (!offers.length) return "No Offers";

        return (
          <button
            className="btn btn-sm btn-outline-info"
            onClick={() => {
              setSelectedOffersOrder(params.data);
              setShowOffersModal(true);
            }}>
            View {offers.length} {offers.length === 1 ? "Offer" : "Offers"}
          </button>
        );
      },
    },
    {
      headerName: "Order Revisions",
      field: "order_revisions",
      width: 180,
      resizable: true,
      sortable: false,
      filter: false,
      cellRenderer: (params) => {
        const revisions = params.value || [];
        if (!revisions.length) return "No Revisions";

        return (
          <button
            className="btn btn-xs btn-outline-info"
            onClick={() => {
              setSelectedRevisionOrder(params.data); // pass full order row
              setShowRevisionsModal(true);
            }}>
            View {revisions.length} {revisions.length === 1 ? "Revision" : "Revisions"}
          </button>
        );
      },
    },
  ];

  const fetchOrdersData = (brandId, currentFilters = null) => {
    if (pendingRequestRef.current) {
      pendingRequestRef.current.abort();
    }

    const controller = new AbortController();
    pendingRequestRef.current = controller;

    setloadingFetch(true);

    // Always use a structured filter object to ensure consistency
    const apiFilters = currentFilters ? { ...currentFilters } : {};

    // Always ensure brands are set correctly
    if (!apiFilters.brands || apiFilters.brands.length === 0) {
      apiFilters.brands = [brandId];
    }

    fetchSublyticsOrders(brandId, 1, 1000, apiFilters)
      .then((res) => {
        if (!res) return;

        // Add index to each row
        const indexedData = res.results.map((item, index) => ({
          ...item,
          index: index + 1,
        }));

        setRowData(indexedData);

        // Update last sync time if available
        if (res.last_sync_time) {
          const syncDate = new Date(res.last_sync_time);
          setLastSyncTime(syncDate.toLocaleString());
        }
      })
      .catch((error) => {
        if (error.name !== "AbortError") {
          console.error("Error fetching Sublytics orders:", error);
          message.error("Failed to fetch Sublytics orders.");
        }
      })
      .finally(() => {
        setloadingFetch(false);
        pendingRequestRef.current = null;
      });
  };

  const handleSync = () => {
    if (!filters || !filters.brands || filters.brands.length === 0) {
      message.warning("Please select a brand first");
      return;
    }

    const brandId = filters.brands[0];
    setSyncInProgress(true);
    message.loading("Syncing Sublytics orders...", 0);

    syncSublyticsOrders(brandId)
      .then((res) => {
        message.destroy();
        message.success(`Successfully synced Sublytics orders. ${res.message || ""}`);

        if (res.last_sync_time) {
          const syncDate = new Date(res.last_sync_time);
          setLastSyncTime(syncDate.toLocaleString());
        } else {
          setLastSyncTime(new Date().toLocaleString());
        }

        fetchOrdersData(brandId, filters);
      })
      .catch((error) => {
        message.destroy();
        console.error("Error syncing Sublytics orders:", error);
        message.error("Failed to sync Sublytics orders. " + (error.response?.data?.error || ""));
      })
      .finally(() => {
        setSyncInProgress(false);
      });
  };
  const isLoadingRef = useRef(false);
  const lastFiltersRef = useRef(null);
  useEffect(() => {
    if (filters && filters.brands && filters.brands.length > 0 && !isLoadingRef.current) {
      const filtersString = JSON.stringify(filters);
      if (filtersString !== lastFiltersRef.current) {
        lastFiltersRef.current = filtersString;
        isLoadingRef.current = true;
        fetchOrdersData(filters.brands[0], filters);
        isLoadingRef.current = false;
      }
    } else {
      setloadingFetch(false);
    }
  }, [filters, refreshTrigger]);

  // useEffect(() => {
  //   if (refreshTrigger > 0 && filters && filters.brands && filters.brands.length > 0) {
  //     setloadingFetch(true);
  //     fetchOrdersData(filters.brands[0], filters);
  //   }
  // }, [refreshTrigger]);

  return (
    <div className="">
      <div className="page-header">
        <div className="add-item d-flex">
          <div className="page-title">
            <h4>Sublytics Orders</h4>
          </div>
        </div>
        <ul className="table-top-head">
          <li>{lastSyncTime && <p className="text-muted">Last synced: {lastSyncTime}</p>}</li>
          <li>
            <OverlayTrigger placement="top" overlay={<Tooltip>Collapse</Tooltip>}>
              <a
                id="collapse-header"
                className={data ? "active" : ""}
                onClick={() => dispatch(setToogleHeader(!data))}
                style={{ cursor: "pointer" }}>
                <ChevronUp />
              </a>
            </OverlayTrigger>
          </li>
        </ul>
        <div className="page-btn">
          <button
            className="btn btn-added"
            onClick={handleSync}
            disabled={!filters?.brands?.length || syncInProgress}>
            <RotateCcw className="me-2 iconsize" />
            Sync Sublytics Orders
          </button>
        </div>
      </div>

      <div
        className="ag-theme-quartz mt-3"
        style={{ width: "100%", height: "calc(70vh - 50px)", position: "relative" }}>
        {loadingFetch && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              zIndex: 1000,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}>
            <div
              className="spinner-border text-primary"
              role="status"
              style={{ width: "3rem", height: "3rem" }}>
              <span className="visually-hidden">Loading...</span>
            </div>
            <div style={{ marginTop: "15px", fontWeight: "bold" }}>Loading orders...</div>
          </div>
        )}
        <AgGridReact
          ref={gridRef}
          rowData={rowData}
          columnDefs={columnDefs}
          pagination={false}
          defaultColDef={{ sortable: true, filter: true, resizable: true }}
          loading={loadingFetch}
          onGridReady={(params) => {
            gridRef.current = params;
            if (params.api) {
              params.api.sizeColumnsToFit();
            }
          }}
        />
      </div>

      <TransactionModal
        visible={showModal}
        onClose={() => setShowModal(false)}
        transaction={selectedOrder}
        timezone={timezone}
      />

      <OrderOffersModal
        showOffersModal={showOffersModal}
        setShowOffersModal={setShowOffersModal}
        selectedOffersOrder={selectedOffersOrder}
      />

      <OrderRevisionModal
        showRevisionsModal={showRevisionsModal}
        setShowRevisionsModal={setShowRevisionsModal}
        selectedRevisionOrder={selectedRevisionOrder}
        timezone={timezone}
      />

      <RealAuthTransactionsModal
        visible={showRealAuthModal}
        onClose={() => setShowRealAuthModal(false)}
        order={selectedRealAuthOrder}
        timezone={timezone}
      />

      <RealNMITransactionsModal
        visible={showRealNMIModal}
        onClose={() => setShowRealNMIModal(false)}
        order={selectedRealNMIOrder}
        timezone={timezone}
      />

      <TigerTechSalesModal
        visible={showTigerTechModal}
        onClose={() => setShowTigerTechModal(false)}
        tigerTechSaleId={selectedTigerTechSaleId}
        timezone={timezone}
      />

      <WebOrdersWithoutStripeModal
        visible={showWebOrdersWithoutStripeModal}
        onClose={() => setShowWebOrdersWithoutStripeModal(false)}
        filters={filters}
        timezone={timezone}
        merchantName={selectedWebOrdersMerchant}
      />
    </div>
  );
};

export default SublyticsOrders;
